import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type Menu03IconProps = IconProps

const Menu03Icon = forwardRef<SVGSVGElement, Menu03IconProps>(
  (props: Menu03IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 12h18M3 6h18M3 18h12"
        fill="none"
      ></path>
    </Icon>
  ),
)

Menu03Icon.displayName = 'Menu03Icon'
Menu03Icon.defaultProps = iconDefaultProps

export type { Menu03IconProps }
export { Menu03Icon }
